import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { createContext, useContext } from 'react';
import { FSMStages } from "./types";
import { useFSMOperations } from "./hooks/useFSMOperations";
import { DEFAULT_TIMEOUT_TIME } from "./hooks/useFSMOperations/helper";
var FSMContext = /*#__PURE__*/createContext({
  stage: FSMStages.IDLE,
  changeStage: function changeStage() {
    return {
      status: 'ok'
    };
  },
  options: {
    blockedTimeout: DEFAULT_TIMEOUT_TIME
  },
  addReachedHandler: function addReachedHandler() {}
});
export var FSMProvider = function FSMProvider(_ref) {
  var children = _ref.children,
    params = _objectWithoutProperties(_ref, _excluded);
  var value = useFSMOperations(params);
  return /*#__PURE__*/React.createElement(FSMContext.Provider, {
    value: value
  }, children);
};
export var useFSM = function useFSM() {
  return useContext(FSMContext);
};